import { render, staticRenderFns } from "./discover_form.vue?vue&type=template&id=66226a38&"
import script from "./discover_form.vue?vue&type=script&lang=js&"
export * from "./discover_form.vue?vue&type=script&lang=js&"
import style0 from "./discover_form.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports